var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { GenericError, MfaRequiredError } from '@auth0/auth0-spa-js';
import fetch from 'unfetch';
import { DEFAULT_FETCH_TIMEOUT_MS, DEFAULT_SILENT_TOKEN_RETRY_COUNT } from './constants';
import { sendMessage } from './worker-utils';
export const createAbortController = () => new AbortController();
const dofetch = (fetchUrl, fetchOptions) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(fetchUrl, fetchOptions);
    return {
        ok: response.ok,
        json: yield response.json()
    };
});
const fetchWithoutWorker = (fetchUrl, fetchOptions, timeout) => __awaiter(void 0, void 0, void 0, function* () {
    const controller = createAbortController();
    fetchOptions.signal = controller.signal;
    let timeoutId;
    // The promise will resolve with one of these two promises (the fetch or the timeout), whichever completes first.
    return Promise.race([
        dofetch(fetchUrl, fetchOptions),
        new Promise((_, reject) => {
            timeoutId = setTimeout(() => {
                controller.abort();
                reject(new Error("Timeout when executing 'fetch'"));
            }, timeout);
        })
    ]).finally(() => {
        clearTimeout(timeoutId);
    });
});
const fetchWithWorker = (fetchUrl, audience, scope, fetchOptions, timeout, worker, useFormData) => __awaiter(void 0, void 0, void 0, function* () {
    return sendMessage({
        auth: {
            audience,
            scope
        },
        timeout,
        fetchUrl,
        fetchOptions,
        useFormData
    }, worker);
});
export const switchFetch = (fetchUrl, audience, scope, fetchOptions, worker, useFormData, timeout = DEFAULT_FETCH_TIMEOUT_MS) => __awaiter(void 0, void 0, void 0, function* () {
    if (worker) {
        return fetchWithWorker(fetchUrl, audience, scope, fetchOptions, timeout, worker, useFormData);
    }
    else {
        return fetchWithoutWorker(fetchUrl, fetchOptions, timeout);
    }
});
export function getJSON(url, timeout, audience, scope, options, worker, useFormData) {
    return __awaiter(this, void 0, void 0, function* () {
        let fetchError = null;
        let response;
        for (let i = 0; i < DEFAULT_SILENT_TOKEN_RETRY_COUNT; i++) {
            try {
                response = yield switchFetch(url, audience, scope, options, worker, useFormData, timeout);
                fetchError = null;
                break;
            }
            catch (e) {
                // Fetch only fails in the case of a network issue, so should be
                // retried here. Failure status (4xx, 5xx, etc) return a resolved Promise
                // with the failure in the body.
                // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
                fetchError = e;
            }
        }
        if (fetchError) {
            // unfetch uses XMLHttpRequest under the hood which throws
            // ProgressEvents on error, which don't have message properties
            fetchError.message = fetchError.message || 'Failed to fetch';
            throw fetchError;
        }
        const _a = response.json, { error, error_description } = _a, data = __rest(_a, ["error", "error_description"]), { ok } = response;
        if (!ok) {
            const errorMessage = error_description || `HTTP error. Unable to fetch ${url}`;
            if (error === 'mfa_required') {
                throw new MfaRequiredError(error, errorMessage, data.mfa_token);
            }
            throw new GenericError(error || 'request_error', errorMessage);
        }
        return data;
    });
}
//# sourceMappingURL=http.js.map